
import { defineComponent, reactive, toRefs, computed } from 'vue'
import { useStore } from 'vuex'
import customBtn from '@/components/common/btn/custom-btn.vue'
import { countAd } from '@/http/api'
export default defineComponent({
  name: '',
  components: { customBtn },
  props: {
    list: {
      type: Array,
      default() {
        return []
      },
    },
    noResult: {
      type: Number,
      default: 0,
    },
    isShowLoading: {
      type: Boolean,
      default: false,
    },
  },
  setup() {
    const store = useStore()
    const data = reactive({
      activityInfo: computed(() => store.state.activityInfo),
      browserEnv: computed(() => store.state.browserEnv),
    })
    const methods = {
      // 跳转行情页
      jumpToNewsPage(item: any) {
        countAd(6316)
        if (data.browserEnv === 1) {
          window.location.href = item.dealerNewsUrl
        } else if (data.browserEnv === 2 || data.browserEnv === 3) {
          window.location.href = item.dealerNewsUrl + '?ad=15081'
        }
      },
      // 跳转店铺页
      jumpToDealerShopPage(item: any) {
        countAd(6317)
        if (data.browserEnv === 1) {
          window.location.href = item.appDealerUrl
        } else if (data.browserEnv === 2 || data.browserEnv === 3) {
          window.location.href = item.h5DealerUrl + '?ad=15081'
        }
      },
    }
    return {
      ...toRefs(data),
      ...methods,
    }
  },
})
